import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import apiConfig from '@constants/apiConfig';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { SelectField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { Col, Form, Row } from 'antd';

const OrderDisplayMappingForm = ({ detail, form, onSubmit, setIsChangedFormValues }) => {
    const location = useLocation();
    const translate = useTranslate();
    const queryParams = new URLSearchParams(location.search);
    const orderDisplayId = queryParams.get('orderDisplayId');
    const deviceId = queryParams.get('deviceId');

    const [selectedValue, setSelectedValue] = useState(null);
    const [orderDisplayNumberOptions, setOrderDisplayNumberOptions] = useState([]);

    const { execute: executeNotExist } = useFetch(apiConfig.orderDisplay.notExist);

    useEffect(() => {
        if (detail) {
            form.setFieldsValue({
                orderDisplayNumber: detail?.orderDisplayNumber,
            });
            setSelectedValue(detail?.orderDisplayNumber || null);
        } else {
            form.resetFields();
            setSelectedValue(null);
        }
    }, [detail]);

    useEffect(() => {
        if (deviceId) {
            executeNotExist({
                params: {
                    parentId: deviceId,
                },
                onCompleted: (res) => {
                    setOrderDisplayNumberOptions(res.data || []);
                },
            });
        }
    }, [deviceId]);

    const handleSubmit = (values) => {
        const preparedData = {
            ...values,
        };
        if (detail?.id) {
            preparedData.id = detail.id;
        }
        onSubmit(preparedData);
    };

    return (
        <Form form={form} layout="vertical" onFinish={handleSubmit} onValuesChange={() => setIsChangedFormValues(true)}>
            <Row gutter={24}>
                <Col span={24}>
                    <SelectField
                        label={translate.formatMessage(commonMessage.readyBoardMappingNumber)}
                        name="orderDisplayNumber"
                        options={[
                            ...orderDisplayNumberOptions
                                .filter(
                                    (item) => item === selectedValue || !selectedValue || item !== selectedValue,
                                )
                                .map((item) => ({
                                    value: item,
                                    label: `${translate.formatMessage(commonMessage.readyBoardMappingNumber)} ${item}`,
                                })),
                            ...(selectedValue && !orderDisplayNumberOptions.includes(selectedValue)
                                ? [
                                    {
                                        value: selectedValue,
                                        label: `${translate.formatMessage(commonMessage.readyBoardMappingNumber)} ${selectedValue}`,
                                    },
                                ]
                                : []),
                        ].sort((a, b) => a.value - b.value)}
                        onChange={(value) => {
                            if (!orderDisplayNumberOptions.includes(detail?.orderDisplayNumber)) {
                                setOrderDisplayNumberOptions([
                                    ...orderDisplayNumberOptions,
                                    detail?.orderDisplayNumber,
                                ]);
                            }
                            setSelectedValue(value);
                        }}
                        allowClear={false}
                        required
                    />
                </Col>
            </Row>
        </Form>
    );
};

export default OrderDisplayMappingForm;
